import * as angular from "angular";
import {IController} from 'angular';
import * as _ from "lodash";
import {TagType} from "../../angular/types/tag.type";

export class tagsMultiSelectCtrl implements IController {

  tagType: TagType;
  selectedIds: any;
  ngPlaceholder: any;
  isDisabled: any;
  isExcludeMode: boolean;
  isAllowExcludeMode: boolean;
  onChange: Function;

  public selectedText: any;

  /* @ngInject */
  constructor(private $mdPanel, private $element) {
  }

  $onInit() {
    this._setSelectedText();
  };

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this._setSelectedText();
    }
  };


  onShowPanel($event) {

    if (!!this.isDisabled) {
      return;
    }

    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.bringoz-select-input')
      .withAnimation(this.$mdPanel.animation.FADE);

    const selectedIdsRef = this.selectedIds || [];
    const tagTypeRef = this.tagType;
    const ngPlaceholderRef = this.ngPlaceholder;
    const isAllowExcludeModeRef = this.isAllowExcludeMode;
    const isExcludeModeRef = this.isExcludeMode;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<bringoz-multi-select-filter-panel ' +
        'type="ctrl.typeRef" ' +
        'selected-ids="ctrl.selectedIdsRef" ' +
        'options="ctrl.optionsRef" ' +
        'option-ids="ctrl.optionIdsRef" ' +
        'ng-placeholder="ctrl.ngPlaceholderRef" ' +
        'panel-ref="ctrl.mdPanelRef" ' +
        'query-map="ctrl.queryMapRef" ' +
        'service-areas-types="ctrl.serviceTypesRef" ' +
        'is-allow-exclude-mode="ctrl.isAllowExcludeModeRef"' +
        'is-exclude-mode="ctrl.isExcludeModeRef"' +
        'exclude-ids="ctrl.excludeIdsRef">' +
        '</bringoz-multi-select-filter-panel>',
      controller: function () {
        this.typeRef = 'tags';
        this.selectedIdsRef = selectedIdsRef;
        this.ngPlaceholderRef = ngPlaceholderRef;
        this.isAllowExcludeModeRef = isAllowExcludeModeRef;
        this.isExcludeModeRef = isExcludeModeRef;
        this.queryMapRef = {
          tagType: tagTypeRef,
        };
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds, isExcludeMode?) => {
        if (selectedIds === 'clickOutsideToClose' || selectedIds === 'escapeToClose') {
          selectedIds = selectedIdsRef;
        }

        this.onChange({ids: selectedIds, isExcludeMode: isExcludeMode});
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onResetFilter() {
    this.onChange({ids: [], isExcludeMode: false});
  }

  private _setSelectedText() {
    let string = '';
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");

    _.forEach(this.selectedIds, (tag, i) => {
      string += tag;
      if ((i + 1) < this.selectedIds.length) {
        string += ', '
      }
    });

    var stringWidth = ctx.measureText(string).width;
    if (this.$element[0]?.clientWidth && ((stringWidth + 80) >= (this.$element[0].clientWidth - 30)) && !!this.selectedIds?.length) {
      string = this.selectedIds[0] + ` +${this.selectedIds.length - 1}`
    }
    this.selectedText = string;
  }


}

angular
  .module('bringoz.admin.tags')
  .component('tagsMultiSelect', {
    bindings: {
      tagType: '@?',
      selectedIds: '<',
      ngPlaceholder: '@?',
      isDisabled: '<?',
      isExcludeMode: '<?',
      isAllowExcludeMode: '<?',
      onChange: '&'
    },
    template: require('./tags-multi-select.html').default,
    controller: tagsMultiSelectCtrl
  });
